<template>
  <div id="app" @contextmenu.prevent>
    <div id="context" class="context">
      <router-view/>
    </div>
  </div>
</template>
